/**
 * Which dossier the Actes section should open on arrival.
 *
 * The portal has no router, so travelling between two sections is done the way
 * everything else here does it: a tiny module store the destination reads once
 * it is on screen. The case page sets it and asks for the section; the section
 * picks it up and clears it, so a later visit does not reopen yesterday's
 * dossier.
 */
let pending: string | null = null;
let pendingTab: string | null = null;
const listeners = new Set<() => void>();

/** Name a dossier, a page, or both. Either may be null. */
export function setActesFocus(id: string | null, tab?: string | null): void {
  pending = id;
  pendingTab = tab ?? null;
  listeners.forEach((l) => l());
}

/** Read it AND clear it: it is a one-shot instruction, not a state. */
export function takeActesFocus(): { id: string | null; tab: string | null } {
  const v = { id: pending, tab: pendingTab };
  pending = null;
  pendingTab = null;
  return v;
}

export function onActesFocus(cb: () => void): () => void {
  listeners.add(cb);
  return () => { listeners.delete(cb); };
}
